import React from 'react';
import Image from '../pics'; 
import BusinessEnquiryForm from './contform/business';
import FeedbackForm from './contform/feed';
import FranchiseeEnquiryForm from './contform/franchisee';
import RateRequestForm from './contform/rate';

function MyForm() {
  return (
    <div>
      <div className="uk-section">
        <div className="uk-container">
          <div className="form">
            <ul className="uk-subnav uk-subnav-pill" uk-switcher="animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
              <li><a href="/#" className='uk-text-capitalize'>Business Enquiry</a></li>
              <li><a href="/#" className='uk-text-capitalize'>Feedback</a></li>
              <li><a href="/#" className='uk-text-capitalize'>Franchisee Enquiry</a></li>
              <li><a href="/#" className='uk-text-capitalize'>Request Rate</a></li>
            </ul>

            <div className="uk-switcher uk-margin">
              {/* Business Enquiry Form */}
              <div>
                <div className="uk-text-center" data-uk-grid>
                  <div className="uk-width-1-2@m">
                    <h2 className='text-primary'>Business Enquiry</h2>
                    <BusinessEnquiryForm/>
                  </div>
                  <div className="uk-width-1-2@m">
                    <div className="uk-card">
                      <img src={Image.BUSINESS} alt="Business Enquiry" />
                    </div>
                  </div>
                </div> 
              </div>

              {/* Feedback Form */}
              <div>
                <div className="uk-text-center" data-uk-grid>
                  <div className="uk-width-1-2@m">
                    <div className="uk-card">
                      <img src={Image.FEEDBACK} alt="Feedback" />
                    </div>
                  </div>
                  <div className="uk-width-1-2@m">
                    <h2 className='text-primary'>Feedback</h2>
                    <FeedbackForm/>
                  </div>
                </div>
              </div>

              {/* Franchisee Enquiry Form */}
              <div>
                <div className="uk-text-center" data-uk-grid>
                  <div className="uk-width-1-2@m">
                    <h2 className='text-primary'>Franchisee Enquiry</h2>
                    <FranchiseeEnquiryForm/>
                  </div>
                  <div className="uk-width-1-2@m">
                    <div className="uk-card">
                      <img src={Image.FRANCHISEE} alt="Franchisee Enquiry" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Rate Request Form */}
              <div>
                <div className="uk-text-center" data-uk-grid>
                  <div className="uk-width-1-2@m">
                    <div className="uk-card">
                      {/* Using the BUSINESS image as a placeholder for Request Rate, or could use another if available */}
                      <img src={Image.BUSINESS} alt="Request Rate" />
                    </div>
                  </div>
                  <div className="uk-width-1-2@m">
                    <h2 className='text-primary'>Request Rate</h2>
                    <RateRequestForm/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyForm;
